import { Platform } from 'react-native';

import { useSafeBottomPadding } from '../components/SafeBottomArea';
import {
  getEmbeddedSidebarFooterNavPaddingBottom,
  REQUEST_FORM_WEB_SIDEBAR_FOOTER_NAV_PADDING_BOTTOM,
} from '../constants/requestFormLayout';

/**
 * Extra bottom padding for pinned sidebar footer nav icons (Documents, Summary)
 * when the minimized rail or embedded overlay drawer shares a row with the
 * native request footer band.
 */
export function useEmbeddedSidebarFooterNavPadding(
  embeddedInFrame: boolean,
): number | undefined {
  const safeBottomPadding = useSafeBottomPadding();

  if (Platform.OS === 'web') {
    return REQUEST_FORM_WEB_SIDEBAR_FOOTER_NAV_PADDING_BOTTOM;
  }

  if (!embeddedInFrame) {
    return undefined;
  }

  return getEmbeddedSidebarFooterNavPaddingBottom(safeBottomPadding);
}
